import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

export const Auth0LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Button
      mt="24px"
      width="full"
      fontWeight="500"
      fontSize="small"
      bgColor="white"
      borderColor={colors.aurora['400']}
      borderWidth="medium"
      color={colors.aurora['400']}
      onClick={() => loginWithRedirect()}
    >
      Sign in with SSO
    </Button>
  );
};
